import React from 'react';

import AdminTime from './AdminTime';
import ClientBadges from './ClientBadges';
import { Box, styled } from '@mui/material';

const StyledBox = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '1rem',
  left: '1rem',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: theme.spacing(0.5),
  [theme.breakpoints.down('lg')]: {
    display: 'none',
  },
}));

const AdminHeader = () => {
  return (
    <StyledBox>
      <AdminTime />
      <ClientBadges />
    </StyledBox>
  );
};

export default AdminHeader;